import React from "react";
import AllSalesQuotations from "./SalesQuotationModule/AllSalesQuotations";

const SalesQuotations = () => {
  return (
    <div>
      <AllSalesQuotations />
    </div>
  );
};

export default SalesQuotations;
